export default "__VITE_ASSET__DUfT4CvD__"